import withNavigate from "../../../routes/withNavigate.jsx";
import BulkPhotoDownloaderContainer from "./BulkPhotoDownloaderContainer.jsx";
import BulkPhotoDownloaderStore from "./BulkPhotoDownloaderStore.js";

export default BulkPhotoDownloaderStore(withNavigate(BulkPhotoDownloaderContainer));